import React, { Component } from "react";
import { Fragment } from "react";
import LazyLoad from "react-lazyload";
import Loading from "./loader";
import { enqueueSnackbar } from "notistack";
import { withRouter } from 'react-router-dom';
import { LuUsers, LuUserPlus } from "react-icons/lu";
import { AiOutlineSchedule, AiOutlineEdit } from "react-icons/ai";
import { FileDoneOutlined, HomeOutlined, RightOutlined, LeftOutlined } from "@ant-design/icons";
import UserFormModal from "./UserFormModal";
import StateWarning from './StateWarning';
import Flatpickr from 'react-flatpickr';
import { Russian } from 'flatpickr/dist/l10n/ru';
import 'flatpickr/dist/flatpickr.css';

class Info extends Component {
    constructor(props) {
        super(props);
        const initialStartDate = "01.01.2020";
        const initialEndDate = "31.12.2026";

        // Получаем сохраненную вкладку из localStorage или используем значение по умолчанию
        const savedActiveMenuKey = localStorage.getItem('activeMeetingTab') || 'available';

        this.state = {
            selectedMeetingId: null,
            meetings: [],
            issuers: [],
            isLoading: true,
            isStaffLoading: true,
            pacsVotesData: null,
            pacsVotes: false,
            selectedAccountId: null,
            selectedUniquifier: null,
            isCreateUserModalVisible: false,
            activeMenuKey: savedActiveMenuKey, // Используем сохраненное значение
            isMenuOpen: false,
            totalHeaderHeight: 0,
            // Состояния для выбранных в интерфейсе дат (строки)
            selectedStartDate: initialStartDate,
            selectedEndDate: initialEndDate,
            // Состояния для примененных фильтров (строки)
            filterStartDate: initialStartDate,
            filterEndDate: initialEndDate
        };
    }

    componentDidMount() {
        this.setState({ pacsVotes: false });
        this.checkStaffAndFetch();

        const headerBackground = document.querySelector('.background');
        const headerNav = document.querySelector('.ul');
        const totalHeaderHeight = headerBackground?.offsetHeight + headerNav?.offsetHeight || 0;

        this.setState({ totalHeaderHeight });
    }

    handleResize = () => {
        const headerBackground = document.querySelector('.background');
        const headerNav = document.querySelector('.ul');

        if (headerBackground && headerNav) {
            const newHeight = headerBackground.offsetHeight + headerNav.offsetHeight;
            if (Math.abs(newHeight - this.state.totalHeaderHeight) > 5) {
                this.setState({ totalHeaderHeight: newHeight });
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevProps.is_staff !== this.props.is_staff ||
            prevProps.is_superuser !== this.props.is_superuser
        ) {
            this.checkStaffAndFetch();
        }

        if (prevState.totalHeaderHeight === 0 && this.state.totalHeaderHeight > 0) {
            window.addEventListener('resize', this.handleResize);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    checkStaffAndFetch() {
        const { is_staff, is_superuser } = this.props;
        if (is_staff || is_superuser) {
            this.setState({ isStaffLoading: false });
        } else {
            this.fetchMeetings();
        }
    }

    toggleMenu = () => {
        this.setState(prevState => ({ isMenuOpen: !prevState.isMenuOpen }));
    };

    handleMenuSelect = (key) => {
        this.setState({
            activeMenuKey: key,
            isMenuOpen: false,
            selectedMeetingId: null,
            pacsVotes: false
        });

        // Сохраняем выбранную вкладку в localStorage
        localStorage.setItem('activeMeetingTab', key);
    };

    async getPacsVotes() {
        const { meetings, selectedMeetingId } = this.state;
        const selectedMeeting = meetings.find(m => m.meeting_id === selectedMeetingId);
        if (!selectedMeeting) {
            enqueueSnackbar('Собрание не найдено', { variant: 'error' });
            return;
        }
        const meeting_id = selectedMeeting.meeting_id;

        try {
            const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
            const userRes = await fetch(`${API_ADDRESS}get_pac_votes/${meeting_id}/`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });
            if (userRes.ok) {
                const pacsData = await userRes.json();
                this.setState({ pacsVotesData: pacsData }, () => {
                    if (pacsData && pacsData.length === 1) {
                        const selectedAccountId = pacsData[0].account_id;
                        const selectedUniquifier = pacsData[0].uniquifier;
                        this.handleStartVoteClick(selectedAccountId, selectedUniquifier);
                    }
                });
            } else {
                console.error('Ошибка:', userRes.statusText);
                this.setState({ pacsVotesData: [] }, () => {
                    enqueueSnackbar('Не удалось загрузить пакеты голосов', { variant: 'error' });
                });
            }
        } catch (e) {
            console.log(e);
            this.setState({ pacsVotesData: [] }, () => {
                enqueueSnackbar('Ошибка сети при загрузке пакетов голосов', { variant: 'error' });
            });
        }
    }

    async fetchMeetings() {
        const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
        const userRes = await fetch(`${API_ADDRESS}get_meetings/`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            },
        });

        if (userRes.ok) {
            const data = await userRes.json();
            const { meetings, issuers } = data;
            localStorage.setItem('meetings', JSON.stringify(meetings));

            this.setState({ meetings, issuers, isLoading: false }, () => {
                const savedIndex = localStorage.getItem('restoreSelectedIndex');
                const index = parseInt(savedIndex, 10);

                if (savedIndex !== null && !isNaN(index) && index >= 0 && index < meetings.length) {
                    localStorage.removeItem('restoreSelectedIndex');
                }
            });
        } else {
            alert("Произошла ошибка. Попробуйте обновить страницу.");
            console.error('Ошибка:', userRes.statusText);
            this.setState({ isLoading: false });
        }

        if (userRes.statusText === "Unauthorized") {
            alert("Время сессии истекло. Пожалуйста выполните вход.");
            document.getElementById("logoutBttn").click();
        }
    }

    getIssuerName(issuerId) {
        const { issuers } = this.state;
        const issuer = issuers.find((issuer) => issuer.issuer_id === issuerId);
        return issuer ? issuer.full_name : "Отсутствует";
    }

    handleBackClick = () => {
        this.setState({
            pacsVotes: false,
            pacsVotesData: null,
            selectedAccountId: null,
            selectedUniquifier: null
        });
    };

    handleStartVoteClick = (selectedAccountId, selectedUniquifier) => {
        const { meetings, selectedMeetingId, pacsVotesData } = this.state;
        const meeting = meetings.find(m => m.meeting_id === selectedMeetingId);
        if (!meeting) {
            enqueueSnackbar('Собрание не выбрано', { variant: 'error' });
            return;
        }
        const meetingId = meeting.meeting_id;

        if (selectedAccountId === null || selectedUniquifier === null) {
            enqueueSnackbar('Необходимо выбрать пакет голосов', { variant: 'error' });
            return;
        }

        const globalAccessToken = `${meetingId}_${selectedAccountId}_${selectedUniquifier}_${Math.random().toString(36).substring(2, 15)}${Math.random().toString(36).substring(2, 15)}`;
        localStorage.setItem(`globalAccessToken`, globalAccessToken);

        const selectedAccount = pacsVotesData.find(acc => acc.account_id === selectedAccountId && acc.uniquifier === selectedUniquifier);
        if (selectedAccount && selectedAccount.account_fullname) {
            localStorage.setItem(`selectedAccountFullname_${meetingId}_${selectedAccountId}_${selectedUniquifier}`, selectedAccount.account_fullname);
        }

        if (pacsVotesData.length > 1) {
            localStorage.setItem(`isMultiplePacs_${meetingId}_${selectedAccountId}_${selectedUniquifier}`, 'true');
        } else {
            localStorage.removeItem(`isMultiplePacs_${meetingId}_${selectedAccountId}_${selectedUniquifier}`);
        }

        this.props.history.push(`/voteExtended/${meetingId}/${selectedAccountId}/${selectedUniquifier}`);
    };

    handleSelectAccount = (accountId, uniquifier) => {
        this.setState((prevState) => ({
            selectedAccountId: prevState.selectedAccountId === accountId && prevState.selectedUniquifier === uniquifier ? null : accountId,
            selectedUniquifier: prevState.selectedAccountId === accountId && prevState.selectedUniquifier === uniquifier ? null : uniquifier
        }));
    };

    formatDate(dateString) {
        const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
        const date = new Date(dateString);
        return date.toLocaleDateString('ru-RU', options).replace(/\//g, '.');
    }

    handleMeetingsClick = () => {
        this.props.history.push('/voteMeetings');
    };

    handleCreateMeeting = () => {
        this.props.history.push('/voteMeetingCreate');
    };

    handleViewerUsers = () => {
        this.props.history.push('/voteAllUsers');
    };

    getAvailableMeetings = () => {
        return this.state.meetings.filter(m => [1, 2, 3, 4].includes(m.status));
    };

    // Вспомогательная функция для преобразования строки в объект Date
    parseDate = (dateString) => {
        if (!dateString) return null;
        const [day, month, year] = dateString.split('.');
        return new Date(year, month - 1, day);
    };

    // Вспомогательная функция для преобразования объекта Date в строку
    formatDateToString = (date) => {
        if (!date) return '';
        return date.toLocaleDateString('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        }).replace(/\//g, '.');
    };

    // Обработчик нажатия кнопки "Найти"
    handleFind = () => {
        this.setState({
            filterStartDate: this.state.selectedStartDate,
            filterEndDate: this.state.selectedEndDate
        });
    };

    // Обработчик нажатия кнопки "Очистить"
    handleClear = () => {
        this.setState({
            selectedStartDate: "01.01.2020",
            selectedEndDate: "31.12.2026",
            filterStartDate: "01.01.2020",
            filterEndDate: "31.12.2026"
        });
    };

    render() {
        const {
            selectedMeetingId,
            meetings,
            isLoading,
            isStaffLoading,
            pacsVotes,
            pacsVotesData,
            selectedAccountId,
            selectedUniquifier,
            activeMenuKey,
            totalHeaderHeight,
            isMenuOpen,
            selectedStartDate,
            selectedEndDate,
            filterStartDate,
            filterEndDate
        } = this.state;
        const { is_staff, is_superuser } = this.props;

        if ((is_staff || is_superuser) && isStaffLoading) {
            return <Loading />;
        } else if (!(is_staff || is_superuser) && isLoading) {
            return <Loading />;
        }

        if (pacsVotes) {
            if (!pacsVotesData) {
                return <div><Loading /></div>;
            }
        }

        // Админка
        if (is_staff || is_superuser) {
            return (
                <div className="page-container">
                    <div className="admin-dashboard">
                        <h1>Администрирование</h1>
                        <div className="admin-options">
                            {is_superuser && (
                                <>
                                    <div
                                        className="admin-card"
                                        onClick={() => {
                                            if (this.props.is_superuser) {
                                                this.setState({ isCreateUserModalVisible: true });
                                            } else {
                                                enqueueSnackbar('У вас нет доступа к этому разделу', { variant: 'error' });
                                            }
                                        }}
                                    >
                                        <div className="admin-icon user-icon">
                                            <LuUserPlus size={40} color="#000" />
                                        </div>
                                        <div className="admin-label">Создать пользователя</div>
                                    </div>
                                    <div
                                        className="admin-card"
                                        onClick={this.handleViewerUsers}
                                    >
                                        <div className="admin-icon user-icon">
                                            <LuUsers size={40} color="#000" />
                                        </div>
                                        <div className="admin-label">Список пользователей</div>
                                    </div>
                                    <div
                                        className="admin-card"
                                        onClick={this.handleCreateMeeting}
                                    >
                                        <div className="admin-icon user-icon">
                                            <AiOutlineEdit size={40} color="#000" />
                                        </div>
                                        <div className="admin-label">Создать собрание</div>
                                    </div>
                                </>
                            )}
                            <div className="admin-card" onClick={this.handleMeetingsClick}>
                                <div className="admin-icon meeting-icon">
                                    <AiOutlineSchedule size={40} color="#000" />
                                </div>
                                <div className="admin-label">Работа с собраниями</div>
                            </div>
                        </div>
                    </div>
                    <UserFormModal
                        key={this.state.editingUser?.id || 'create'}
                        visible={this.state.isCreateUserModalVisible}
                        onClose={() => this.setState({ isCreateUserModalVisible: false, editingUser: null })}
                        onCreateSuccess={() => {}}
                        onUpdateSuccess={() => {}}
                        userToEdit={this.state.editingUser}
                        currentUserIsSuperuser={this.props.is_superuser}
                        currentUserIsStaff={this.props.is_staff}
                    />
                </div>
            );
        }

        // Переменные для меню
        const availableMeetings = this.getAvailableMeetings();

        // Получаем завершенные собрания с фильтрацией по датам
        const completedMeetings = this.state.meetings
            .filter(m => m.status === 5)
            .filter(meeting => {
                const meetingDate = new Date(meeting.meeting_date);
                const startDateObj = this.parseDate(filterStartDate);
                const endDateObj = this.parseDate(filterEndDate);

                if (!startDateObj || !endDateObj) return false;

                // Устанавливаем время на начало и конец дня для точного сравнения
                startDateObj.setHours(0, 0, 0, 0);
                endDateObj.setHours(23, 59, 59, 999);
                meetingDate.setHours(0, 0, 0, 0);

                return meetingDate >= startDateObj && meetingDate <= endDateObj;
            });

        const currentMeetings = activeMenuKey === 'available' ? availableMeetings : completedMeetings;

        const menuItemStyle = (isActive) => ({
            padding: '12px 16px',
            borderRadius: '6px',
            border: isActive ? '2px solid #ffd700' : '2px solid transparent',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            backgroundColor: isActive ? '#fffbe6' : 'transparent'
        });

        return (
            <div className="page-container" style={{
                display: 'flex',
                minHeight: '100vh',
                position: 'relative'
            }}>
                {/* Кнопка открытия меню */}
                {!isMenuOpen && !pacsVotes && (
                    <div
                      className="menu-toggle-button"
                      onClick={this.toggleMenu}
                    >
                      <span style={{ fontSize: '18px' }}><RightOutlined /></span>
                      <span>МЕНЮ</span>
                    </div>
                )}

                {/* Боковое меню */}
                {isMenuOpen && (
                    <>
                        {/* Оверлей */}
                        <div
                            className="menu-overlay"
                            onClick={this.toggleMenu}
                          />
                        <div
                            className="side-menu"
                            onClick={e => e.stopPropagation()}
                        >
                            {/* Кнопка закрытия меню */}
                            <div
                                className="menu-close-button"
                                onClick={this.toggleMenu}
                            >
                                <span style={{fontSize: '18px'}}><LeftOutlined /></span>
                                <span>МЕНЮ</span>
                            </div>

                            {/* Заголовок меню */}
                            <div className="menu-title">
                                <span>КАТЕГОРИЯ</span>
                            </div>

                            {/* Пункты меню */}
                            <div className="menu-items-container">
                                <div
                                    style={menuItemStyle(activeMenuKey === 'available')}
                                    onClick={() => this.handleMenuSelect('available')}
                                    onMouseEnter={e => {
                                        if (activeMenuKey !== 'available') {
                                            e.currentTarget.style.borderColor = '#ffeb99';
                                        }
                                    }}
                                    onMouseLeave={e => {
                                        if (activeMenuKey !== 'available') {
                                            e.currentTarget.style.borderColor = 'transparent';
                                        }
                                    }}
                                >
                                    <span style={{fontSize: '24px', marginRight: '10px'}}><HomeOutlined/></span>
                                    <span>Доступные собрания</span>
                                </div>

                                <div
                                    style={menuItemStyle(activeMenuKey === 'completed')}
                                    onClick={() => this.handleMenuSelect('completed')}
                                    onMouseEnter={e => {
                                        if (activeMenuKey !== 'completed') {
                                            e.currentTarget.style.borderColor = '#ffeb99';
                                        }
                                    }}
                                    onMouseLeave={e => {
                                        if (activeMenuKey !== 'completed') {
                                            e.currentTarget.style.borderColor = 'transparent';
                                        }
                                    }}
                                >
                                    <span style={{fontSize: '24px', marginRight: '10px'}}><FileDoneOutlined/></span>
                                    <span>Завершённые собрания</span>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {/* Основной контент */}
                <div className={`main-content ${isMenuOpen ? 'menu-open' : ''}`}>
                    {pacsVotes ? (
                        <div>
                            <div className="grid-container5" style={{marginTop: '20px'}}>
                                <b>Выберите пакет голосов</b>
                            </div>
                            {pacsVotesData && pacsVotesData.length > 0 ? (
                                <>
                                    {pacsVotesData.map((vote, index) => (
                                        <div
                                            key={`${vote.account_id}_${vote.uniquifier}`}
                                            className={`grid-container6 ${selectedAccountId === vote.account_id && selectedUniquifier === vote.uniquifier ? 'selected' : ''}`}
                                            style={{
                                                marginTop: '20px',
                                                display: 'flex',
                                                flexDirection: 'column'
                                            }}
                                            onClick={() => this.handleSelectAccount(vote.account_id, vote.uniquifier)}
                                        >
                                            <div>
                                                <b>{vote.account_fullname}</b>
                                            </div>
                                        </div>
                                    ))}
                                    <div className="button-votes" style={{marginTop: '20px'}}>
                                        <button2 className="button2" onClick={this.handleBackClick}>
                                            <b>Назад</b>
                                        </button2>
                                        <button2
                                            className={`button2 ${!(selectedAccountId !== null && selectedUniquifier !== null) ? 'disabled' : ''}`}
                                            onClick={() => this.handleStartVoteClick(selectedAccountId, selectedUniquifier)}
                                            disabled={!(selectedAccountId !== null && selectedUniquifier !== null)}
                                        >
                                            <b>Далее</b>
                                        </button2>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div style={{
                                        textAlign: 'center',
                                        margin: '40px 0',
                                        fontSize: '18px',
                                    }}>
                                        <StateWarning message="Нет доступных пакетов голосов"/>
                                    </div>
                                    <div className="button-votes" style={{marginTop: '20px'}}>
                                        <button2 className="button2" onClick={this.handleBackClick}>
                                            <b>Назад</b>
                                        </button2>
                                        <button2
                                            className={`button2 ${!selectedAccountId ? 'disabled' : ''}`}
                                            onClick={() => this.handleStartVoteClick(selectedAccountId)}
                                            disabled={!selectedAccountId}
                                        >
                                            <b>Далее</b>
                                        </button2>
                                    </div>
                                </>
                            )}
                        </div>
                    ) : (
                        <>
                            <div className="header-container">
                                <h1>
                                    {activeMenuKey === 'available' ? 'Доступные собрания' : 'Завершённые собрания'}
                                </h1>
                            </div>

                            {/* Панель фильтрации для завершенных собраний */}
                            {activeMenuKey === 'completed' && (
                                <div className="filter-container">
                                    <div className="date-range-group">
                                        <div className="date-input-wrapper">
                                            <div className="date-label">От</div>
                                            <Flatpickr
                                                className="date-picker"
                                                options={{
                                                    locale: Russian,
                                                    dateFormat: "d.m.Y",
                                                    allowInput: true,
                                                    formatDate: (date) => {
                                                        return date.toLocaleDateString('ru-RU', {
                                                            day: '2-digit',
                                                            month: '2-digit',
                                                            year: 'numeric'
                                                        }).replace(/\//g, '.');
                                                    }
                                                }}
                                                value={selectedStartDate}
                                                onChange={([date]) => {
                                                    if (date) {
                                                        const formattedDate = this.formatDateToString(date);
                                                        this.setState({ selectedStartDate: formattedDate });
                                                    }
                                                }}
                                            />
                                        </div>

                                        <div className="date-separator">-</div>

                                        <div className="date-input-wrapper">
                                            <div className="date-label">До</div>
                                            <Flatpickr
                                                className="date-picker"
                                                options={{
                                                    locale: Russian,
                                                    dateFormat: "d.m.Y",
                                                    allowInput: true,
                                                    formatDate: (date) => {
                                                        return date.toLocaleDateString('ru-RU', {
                                                            day: '2-digit',
                                                            month: '2-digit',
                                                            year: 'numeric'
                                                        }).replace(/\//g, '.');
                                                    }
                                                }}
                                                value={selectedEndDate}
                                                onChange={([date]) => {
                                                    if (date) {
                                                        const formattedDate = this.formatDateToString(date);
                                                        this.setState({ selectedEndDate: formattedDate });
                                                    }
                                                }}
                                            />
                                        </div>

                                        <div className="filter-buttons">
                                            <button2 className="filter-button find-button" onClick={this.handleFind}>
                                                <b>Найти</b>
                                            </button2>
                                            <button2 className="filter-button clear-button" onClick={this.handleClear}>
                                                <b>Очистить</b>
                                            </button2>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {currentMeetings.length > 0 ? (
                                <div className="meetings-list">
                                    {currentMeetings.map((item, index) => (
                                        <div className="meeting-card" key={`container-${item.meeting_id}`}>
                                            <LazyLoad height={200} once>
                                                <div
                                                    className={selectedMeetingId === item.meeting_id ? 'selected' : ''}
                                                    onClick={() => {
                                                        const meetingId = item.meeting_id;
                                                        if (meetingId !== null) {
                                                            this.setState({
                                                                selectedMeetingId: meetingId,
                                                                pacsVotes: true
                                                            }, () => {
                                                                this.getPacsVotes();
                                                            });
                                                        } else {
                                                            enqueueSnackbar('Неизвестная ошибка', {variant: 'error'});
                                                        }
                                                    }}
                                                >
                                                    <div className="meeting-content">
                                                        <div>
                                                            <div className="content" style={{marginBottom: '10px'}}>
                                                                {item.meeting_name}
                                                            </div>
                                                            <div className="content">
                                                                Дата собрания: <b>{this.formatDate(item.meeting_date)}</b>
                                                            </div>
                                                            <div className="content">
                                                                Имя эмитента: <b>{this.getIssuerName(item.issuer)}</b>
                                                            </div>
                                                        </div>
                                                        <div className="arrow-icon">
                                                            <b>&nbsp;></b>
                                                        </div>
                                                    </div>
                                                </div>
                                            </LazyLoad>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="no-meetings-message">
                                    <b>
                                        {activeMenuKey === 'available'
                                            ? <StateWarning message="На данный момент нет доступных собраний"/>
                                            : <StateWarning message="На данный момент нет завершенных собраний"/>}
                                    </b>
                                </div>
                            )}
                        </>
                    )}
                </div>

                <UserFormModal
                    key={this.state.editingUser?.id || 'create'}
                    visible={this.state.isCreateUserModalVisible}
                    onClose={() => this.setState({ isCreateUserModalVisible: false, editingUser: null })}
                    onCreateSuccess={() => {}}
                    onUpdateSuccess={() => {}}
                    userToEdit={this.state.editingUser}
                    currentUserIsSuperuser={this.props.is_superuser}
                    currentUserIsStaff={this.props.is_staff}
                />
            </div>
        );
    }
}

export default withRouter(Info);